/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Story_Linked_ToInputs */

const en_story_linked_to = /** @type {(inputs: Story_Linked_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linked to: ${i?.title}`)
};

const es_story_linked_to = /** @type {(inputs: Story_Linked_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vinculado a: ${i?.title}`)
};

const fr_story_linked_to = /** @type {(inputs: Story_Linked_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lié à : ${i?.title}`)
};

const de_story_linked_to = /** @type {(inputs: Story_Linked_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verlinkt mit: ${i?.title}`)
};

const id_story_linked_to = /** @type {(inputs: Story_Linked_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Terkait dengan: ${i?.title}`)
};

/** @type {(inputs: Story_Linked_ToInputs) => LocalizedString} */
const ja_story_linked_to = en_story_linked_to;

/** @type {(inputs: Story_Linked_ToInputs) => LocalizedString} */
const zh_story_linked_to = en_story_linked_to;

/** @type {(inputs: Story_Linked_ToInputs) => LocalizedString} */
const ar_story_linked_to = en_story_linked_to;

/** @type {(inputs: Story_Linked_ToInputs) => LocalizedString} */
const it_story_linked_to = en_story_linked_to;

/** @type {(inputs: Story_Linked_ToInputs) => LocalizedString} */
const ru_story_linked_to = en_story_linked_to;

/** @type {(inputs: Story_Linked_ToInputs) => LocalizedString} */
const pt_story_linked_to = en_story_linked_to;

/** @type {(inputs: Story_Linked_ToInputs) => LocalizedString} */
const ko_story_linked_to = en_story_linked_to;

/**
* | output |
* | --- |
* | "Linked to: {title}" |
*
* @param {Story_Linked_ToInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_linked_to = /** @type {((inputs: Story_Linked_ToInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Linked_ToInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_linked_to(inputs)
	if (locale === "es") return es_story_linked_to(inputs)
	if (locale === "fr") return fr_story_linked_to(inputs)
	if (locale === "de") return de_story_linked_to(inputs)
	if (locale === "ja") return ja_story_linked_to(inputs)
	if (locale === "zh") return zh_story_linked_to(inputs)
	if (locale === "ar") return ar_story_linked_to(inputs)
	if (locale === "id") return id_story_linked_to(inputs)
	if (locale === "it") return it_story_linked_to(inputs)
	if (locale === "ru") return ru_story_linked_to(inputs)
	if (locale === "pt") return pt_story_linked_to(inputs)
	return ko_story_linked_to(inputs)
});